import { FC, useEffect, useRef, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Header from "../layouts/header";
import Footer from "../layouts/footer";
const ProjectGranteeEdit: FC = () => {
  return (
    <div>
      <Header />
      <div className="midCon pb-2">
        <section className="pt-4 pb-4 pt-md-5 pb-md-5">
          <div className="container">
            <div className="loginHd mb-1">
              <span className="d-block">Edit Project Grantee Information</span>
              Name/ID of Project Grantee
            </div>
          </div>
        </section>
        <section className="pt-4 pb-4 pt-md-5 pb-md-5 mt-2 whtBg">
          <div className="container">
            <ul className="d-flex flex-wrap p-0 viewList">
              <li className="col-12 col-sm-6">
                <div className="position-relative">
                  <span className="field">Partner Title</span>
                  <input type="text" className="loginInput" defaultValue="Char" />
                </div>
              </li>
              <li className="col-12 col-sm-6">
                <div className="position-relative">
                  <span className="field">Project ID</span>
                  <input type="text" className="loginInput" defaultValue="Num" />
                </div>
              </li>
              <li className="col-12 col-sm-6">
                <div className="position-relative">
                  <span className="field">Grantee Organization Name</span>
                  <input type="text" className="loginInput" defaultValue="Char" />
                </div>
              </li>
              <li className="col-12 col-sm-6">
                <div className="position-relative">
                  <span className="field">Grantees Primary Point of Contact</span>
                  <input type="text" className="loginInput" defaultValue="Num" />
                </div>
              </li>
              <li className="col-12 col-sm-6">
                <div className="position-relative">
                  <span className="field">Grantees Primary Point of Contact Email</span>
                  <input type="text" className="loginInput" defaultValue="exmple@email.com" />
                </div>
              </li>
              <li className="col-12 col-sm-6">
                <div className="position-relative">
                  <span className="field">Calendar Year of Report Submission </span>
                  <input type="text" className="loginInput" defaultValue="Char" />
                </div>
              </li>
              <li className="col-12 col-sm-6">
                <div className="position-relative">
                  <span className="field">Reporting Period</span>
                  <input type="text" className="loginInput" defaultValue="Char" />
                </div>
              </li>
              <li className="col-12 col-sm-6">
                <div className="position-relative">
                  <span className="field">Project Start Date</span>
                  <input type="text" className="loginInput" defaultValue="mm-dd-yy" />
                </div>
              </li>
              <li className="col-12 col-sm-6">
                <div className="position-relative">
                  <span className="field">Project End Date</span>
                  <input type="text" className="loginInput" defaultValue="mm-dd-yy" />
                </div>
              </li>
              <li className="col-12 col-sm-6">
                <div className="position-relative">
                  <span className="field">Total Approved Budget</span>
                  <input type="text" className="loginInput" defaultValue="num" />
                </div>
              </li>
              <li className="col-12">
                <div className="position-relative">
                  <span className="field">Project Description</span>
                  <input type="text" className="loginInput" defaultValue="Char" />
                </div>
              </li>
              <li className="col-12 col-sm-6">
                <div className="position-relative">
                  <span className="field">Comet Planner Version</span>
                  <input type="text" className="loginInput" defaultValue="Yes" />
                </div>
              </li>
              <li className="col-12 col-sm-6">
                <div className="position-relative">
                  <span className="field">Total Producers Enrolled</span>
                  <input type="text" className="loginInput" defaultValue="Num" />
                </div>
              </li>
              <li className="col-12 col-sm-6">
                <div className="position-relative">
                  <span className="field">Total No. Acres Enrolled</span>
                  <input type="text" className="loginInput" defaultValue="Num" />
                </div>
              </li>
              <li className="col-12 col-sm-6">
                <div className="position-relative">
                  <span className="field">Total No. Livestock Enrolled</span>
                  <input type="text" className="loginInput" defaultValue="Char" />
                </div>
              </li>
            </ul>
            <div className="pt-5 text-end">
              <NavLink to="/project-grantee/view">
                <button type="button" className="formBtn cancel">
                  Cancel
                </button>
              </NavLink>
              <NavLink to="/project-grantee">
                <button type="button" className="ms-3 formBtn">
                Save Details
                </button>
              </NavLink>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default ProjectGranteeEdit;
